/**
 * @file useEffectOnce
 * @author chenbo09
 */

import {EffectCallback, useEffect} from 'react';

export default (effect: EffectCallback): void => {
    useEffect(effect, []);
};
